import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  DEMO_LESSON_COURSE_ALL,
  DEMO_LESSON_COURSE_CREATE,
  DEMO_LESSON_COURSE_DELETE,
  DEMO_LESSON_COURSE_LIST,
  DEMO_LESSON_EVALUATION_ASSIGNED,
  DEMO_LESSON_EVALUATION_CATEGORY,
  DEMO_LESSON_EVALUATION_CREATE,
  DEMO_LESSON_EVALUATION_LIST,
  DEMO_LESSON_EVALUATION_PRINCIPAL,
  DEMO_LESSON_EVALUATION_REPORT,
  DEMO_LESSON_EVALUATION_RESPONSE_ALL,
  DEMO_LESSON_EVALUATION_RESPONSE_CREATE,
  DEMO_LESSON_MODULE_ALL,
  DEMO_LESSON_MODULE_CREATE,
  DEMO_LESSON_MODULE_DELETE,
  DEMO_LESSON_MODULE_LIST,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const demoLessonEvaluationCreate = createAsyncThunk(
  DEMO_LESSON_EVALUATION_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_EVALUATION}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonEvaluationCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonEvaluationList = createAsyncThunk(
  DEMO_LESSON_EVALUATION_LIST,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_EVALUATION}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonEvaluationList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonEvaluationPrincipal = createAsyncThunk(
  DEMO_LESSON_EVALUATION_PRINCIPAL,
  async (
    params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_EVALUATION_PRINCIPAL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.demoLessonEvaluationPrincipal(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonEvaluationCategory = createAsyncThunk(
  DEMO_LESSON_EVALUATION_CATEGORY,
  async (
    params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_EVALUATION_CATEGORY}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.demoLessonEvaluationCategory(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonEvaluationResponseCreate = createAsyncThunk(
  DEMO_LESSON_EVALUATION_RESPONSE_CREATE,
  async (
    params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_EVALUATION_RESPONSE}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.demoLessonEvaluationResponseCreate(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonEvaluationResponseAll = createAsyncThunk(
  DEMO_LESSON_EVALUATION_RESPONSE_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_EVALUATION_RESPONSE_ALL}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.demoLessonEvaluationResponseAll(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonEvaluationAssigned = createAsyncThunk(
  DEMO_LESSON_EVALUATION_ASSIGNED,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_EVALUATION_ASSIGNED}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonEvaluationAssigned(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonCourseCreate = createAsyncThunk(
  DEMO_LESSON_COURSE_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_COURSE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonCourseCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonCourseDelete = createAsyncThunk(
  DEMO_LESSON_COURSE_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_COURSE}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonCourseDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonCourseList = createAsyncThunk(
  DEMO_LESSON_COURSE_LIST,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_COURSE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonCourseList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)
export const demoLessonCourseAll = createAsyncThunk(
  DEMO_LESSON_COURSE_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_COURSE_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.demoLessonCourseAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonModuleCreate = createAsyncThunk(
  DEMO_LESSON_MODULE_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_MODULE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonModuleCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonModuleDelete = createAsyncThunk(
  DEMO_LESSON_MODULE_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_MODULE}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonModuleDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonModuleList = createAsyncThunk(
  DEMO_LESSON_MODULE_LIST,
  async (params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_MODULE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.demoLessonModuleList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)
export const demoLessonModuleAll = createAsyncThunk(
  DEMO_LESSON_MODULE_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_MODULE_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.demoLessonModuleAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonEvaluationReport = createAsyncThunk(
  DEMO_LESSON_EVALUATION_REPORT,
  async (
    params: PayloadCreatorParams<`${typeof API.DEMO_LESSON_EVALUATION_REPORT}{id}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.demoLessonEvaluationReport(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const demoLessonEvaluationListClear = createAction(`${DEMO_LESSON_EVALUATION_LIST}/clear`)
export const demoLessonEvaluationPrincipalClear = createAction(`${DEMO_LESSON_EVALUATION_PRINCIPAL}/clear`)
export const demoLessonEvaluationCategoryClear = createAction(`${DEMO_LESSON_EVALUATION_CATEGORY}/clear`)
export const demoLessonEvaluationResponseAllClear = createAction(`${DEMO_LESSON_EVALUATION_RESPONSE_ALL}/clear`)
export const demoLessonEvaluationAssignedClear = createAction(`${DEMO_LESSON_EVALUATION_ASSIGNED}/clear`)

export const demoLessonCourseListClear = createAction(`${DEMO_LESSON_COURSE_LIST}/clear`)
export const demoLessonCourseAllClear = createAction(`${DEMO_LESSON_COURSE_ALL}/clear`)

export const demoLessonModuleListClear = createAction(`${DEMO_LESSON_MODULE_LIST}/clear`)
export const demoLessonModuleAllClear = createAction(`${DEMO_LESSON_MODULE_ALL}/clear`)

export const demoLessonEvaluationReportClear = createAction(`${DEMO_LESSON_EVALUATION_REPORT}/clear`)
